import { Component, OnInit } from '@angular/core';
import { MenuItems } from '../constants/constants';
import { FinanceSetupService } from './finance-setup.service';
import { ObjectNames } from '../constants/constants';
import { AppMainService } from 'src/app/app-main.service';
import { Subject } from 'rxjs';
import { AccountService } from './account/account.service';
import { ChartsOfAccountsRecentItems } from 'src/app/finance/constants/constants';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { FinancialAccount } from 'src/app/finance/models/group.model';
@Component({
  selector: 'app-finance-setup',
  templateUrl: './finance-setup.component.html',
  styleUrls: ['./finance-setup.component.scss']
})
export class FinanceSetupComponent implements OnInit {

  configMenuFinanceSetupItems = [];
  index: number = 0;
  coaForm: FormGroup;
  chartsOfAccountsRecentItems = ChartsOfAccountsRecentItems;
  selectedRecent: any = this.chartsOfAccountsRecentItems[0];
  isActive: boolean = true;
  noCaseFindOrLoadingText = "Loading....";
  allAccounts = [];
  pickValue: boolean | null = null; 

  pageNumber: number = 1;
  pageSize: number = 15;
  totalRecord: number = 0;
  isAscending: boolean = false;
  isChecked: boolean = false;
  searchValue = "";
  searchColumns = "";
  sortBy = "";
  first = 0;
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();
  constructor(private financeService: FinanceSetupService,private appMainService: AppMainService,private fb: FormBuilder,
    private accountService: AccountService,private messageService: MessageService,) { }

  ngOnInit(): void {
    this.getAllChartOfAccounts();
    this.configMenuFinanceSetupItems = [
      {
        label: MenuItems.Account,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddChildChart();
        }
      },
      {
        label: MenuItems.Class,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddClass();
        }
      },
      {
        label: MenuItems.Pricing,
        icon: 'pi pi-plus',
        command: () => {
          ;
        }
      },
    ];
  }

  getIndex(event) {
    this.index = event.index;
  }


  showAddChildChart() {
    this.index = 1;
    this.financeService.setAccount(ObjectNames.BehaviorSubjectVariable);
  }

  showAddClass() {
    this.index = 2;
    this.financeService.setClass(ObjectNames.BehaviorSubjectVariable);
  }
  createAccountForm(account: any): FormGroup {
    return this.fb.group({
      displayAccountNumber: new FormControl(account.displayAccountNumber),
      name: new FormControl(account?.accountType?.name),
    });
  }
  get accountsArray(): FormArray {
    return this.coaForm?.get('accounts') as FormArray;
  }
  
getAllChartOfAccounts() {
  this.sortBy = "order";
  this.isAscending = true;
  let filter = this.selectedRecent.code ? this.selectedRecent.code : "allfinancialaccounts";
  const data = {
      pageNo: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.searchValue,
      searchColumns: this.searchColumns,
      sortBy: this.sortBy,
      isAscending: this.isAscending,
      filter: filter,
      isActive: this.isActive,
      showBalance: true
  };

  this.appMainService.isShowSpinner("loadAccounts");
  this.accountService
      .getAllAccountsWithPagination(data)
      .then((accounts) => {
          this.appMainService.isHideSpinner("loadAccounts");
          let { inventory, headers } = accounts;
          inventory = inventory == null ? [] : inventory;
          headers = headers == null ? [] : headers;
          this.totalRecord = headers["TotalCount"];
          this.noCaseFindOrLoadingText = "No Accounts found";
          this.allAccounts = inventory;
          this.isChecked = !!this.allAccounts[0].displayOperator ;
          this.pickValue = this.isChecked ? this.allAccounts[0].displayOperator == ':' : null;
          this.initform();
      })
      .finally(() => {
          this.appMainService.isHideSpinner("loadAccounts");
      });
}

 initform(){
  this.coaForm = this.fb.group({
    accounts: this.fb.array(this.allAccounts.map(account => this.createAccountForm(account))),
  });
 }

 isSaveEnabled(): boolean {
  return this.accountsArray?.controls.every((account) => {
    const value = account.get('displayAccountNumber')?.value;
    return !!(value && value.toString().trim());
  });
}
onCheckboxChange(): void {
  if (this.isChecked) {
    this.pickValue = true; 
  } else {
    this.pickValue = null; 
  }
}
saveCoa(){
const operator: string = this.isChecked ? (this.pickValue ? ':' : '-') : '';
 const accountsData = this.coaForm?.get('accounts').value;
 const updatedAccounts: FinancialAccount[] = this.allAccounts?.map(account => {
 const matchingAccount = accountsData?.find(data => data.name === account.accountType.name);
  if (matchingAccount) {
    return  {
      id: account?.id,
      createdSource: account?.createdSource,
      updatedSource: account?.updatedSource,
      createdBy: account?.createdBy,
      updatedBy: account?.updatedBy,
      createdDate: account?.createdDate, 
      updatedDate: account?.updatedDate, 
      organizationId: account?.organizationId,
      name: account?.name,
      accountTypeId: account?.accountTypeId,
      subAccountTypeId: account?.subAccountTypeId,
      parentFinancialAccountId: account?.parentFinancialAccountId,
      financialAccountNumber: account?.subAccountTypeId,
      description: account?.description,
      qbdAccountMap: account?.qbdAccountMap,
      qboAccountMap: account?.qboAccountMap,
      qboAccountMapId: account?.qboAccountMapId,
      statusId: account?.statusId,
      order: account?.order,
      balance: account?.balance,
      objectId: account?.objectId,
      financialStatementId: account?.financialStatementId,
      isDefault: account?.isDefault,
      isBank: account?.isBank,
      isDebit: account?.isDebit,
      reconcileEnabled: account?.reconcileEnabled,
      isCreditCard: account?.isCreditCard,
      displayAccountNumber : matchingAccount?.displayAccountNumber ,
      displayNumber: matchingAccount?.displayAccountNumber + (operator ? `${operator}` : '')
    };
  }
  return { ...account  };
});

this.saveOperator(operator, updatedAccounts)
}

saveOperator(operator, updatedAccounts) {
  const operator1 =  operator ? operator : "";
  this.accountService.saveFinancialAccountNumber(operator1, updatedAccounts).subscribe({next: (resp) => {
        this.messageService.add({severity: 'success',summary: 'Success',detail: 'Save successfully...'});
      },
      error: (error) => {
        this.messageService.add({severity: 'error', summary: 'Error',detail: error?.error?.Message ??  'Failed to save COA'});
      },
      complete: () => {
        this.getAllChartOfAccounts();
      }
    }
  );
}
}
